import axios from "axios";
import { toast } from "sonner";
import { getViewingProvider } from "@/auth/AuthContext";

// Downloads and printable pages used to open with window.open(url) or a plain <a href>, which can't send a
// custom header. A super admin inside a provider names the provider with X-Tenant-Id (added by the axios
// interceptor), so those links failed for them with "Open a provider first". Everyone else keeps the plain
// link behaviour; while a provider is open the file is fetched through axios (header, site scope and all) and
// shown from a blob.
const VIEWABLE = /^(application\/pdf|image\/|text\/html)/;

const fileNameOf = (res, fallback) => {
  const cd = res.headers?.["content-disposition"] || "";
  const m = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(cd);
  try { return m ? decodeURIComponent(m[1]) : fallback; } catch { return m ? m[1] : fallback; }
};

const errorText = async (e) => {
  try {
    const d = e.response?.data;
    const txt = d instanceof Blob ? await d.text() : "";
    const detail = txt ? JSON.parse(txt).detail : null;
    if (typeof detail === "string") return detail;
  } catch { /* not JSON */ }
  return "Couldn't open that file";
};

export function openFile(url) {
  if (!getViewingProvider()) { window.open(url, "_blank"); return; }
  const win = window.open("", "_blank");   // opened straight away so a pop-up blocker doesn't swallow it
  axios.get(url, { responseType: "blob" }).then((res) => {
    const type = (res.headers?.["content-type"] || res.data.type || "").split(";")[0];
    const obj = window.URL.createObjectURL(new Blob([res.data], { type }));
    if (VIEWABLE.test(type) && win) { win.location.href = obj; }
    else {
      if (win) win.close();
      const a = document.createElement("a");
      a.href = obj; a.download = fileNameOf(res, "download");
      document.body.appendChild(a); a.click(); a.remove();
    }
    setTimeout(() => window.URL.revokeObjectURL(obj), 120000);
  }).catch(async (e) => { if (win) win.close(); toast.error(await errorText(e)); });
}

/** Drop-in for <a href={api file url}>: unchanged for everyone except a super admin inside a provider. */
export function FileLink({ href, children, ...props }) {
  return <a href={href} {...props} onClick={(e) => { if (getViewingProvider()) { e.preventDefault(); openFile(href); } }}>{children}</a>;
}
